module.exports = __webpack_public_path__ + "static/media/logo4.03c03d18.webp";